module.exports = __webpack_public_path__ + "static/media/volar-internacional.7c90d16b.png";